import wx from 'weixin-js-sdk';
const jsApiList = ['chooseImage','onMenuShareAppMessage', 'onMenuShareTimeline', 'hideMenuItems', "openWithQQBrowser", "scanQRCode" , "getLocation", 'openLocation'];
// import axios from 'axios';
import Vue from "vue";
  
function getJSSDK(url, dataForWeixin, menuList) {
  const requestAPI = 'http://xzlm.bijingauto.cn/api/wxjs_config';
  // console.log(dataForWeixin.linkurl,'是我')
  // axios.post(requestAPI,  {url: encodeURI(url) }).then(({
    Vue.prototype.$post("/api/wxjs_config", {url: encodeURI(url) } ,{url: encodeURI(url) }).then(({
      data
    }) => {
      // console.log(data,'分享反参')
      var Data = data.data;
      wx.config({
        debug: false, // 开启调试模式,开发时可以开启
        appId: Data.appId, // 必填，公众号的唯一标识   由接口返回
        timestamp: Data.timestamp, // 必填，生成签名的时间戳 由接口返回
        nonceStr: Data.nonceStr, // 必填，生成签名的随机串 由接口返回
        signature: Data.signature, // 必填，签名 由接口返回
        jsApiList: jsApiList
      })
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ['chooseImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function(res) {
            console.log(res,'ahaha ')
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          }
        });
        wx.hideMenuItems({
          menuList: menuList,
          success: function (res) { },
          fail: function (res) { }
        });
        wx.onMenuShareAppMessage({
          title: dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          trigger: function trigger(res) { },
          success: function success(res) {
            console.log('已分享');
          },
          cancel: function cancel(res) {
            console.log('已取消');
          },
          fail: function fail(res) {
            alert(JSON.stringify(res));
          }
        });
        // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareTimeline({
          title: dataForWeixin.title,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          trigger: function trigger(res) {
            // alert('用户点击分享到朋友圈');
          },
          success: function success(res) {
            //alert('已分享');
          },
          cancel: function cancel(res) {
            //alert('已取消');
          },
          fail: function fail(res) {
            alert(JSON.stringify(res));
          }
        });
        // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareQQ({
          title: dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          trigger: function trigger(res) {
            //alert('用户点击分享到QQ');
          },
          complete: function complete(res) {
            alert(JSON.stringify(res));
          },
          success: function success(res) {
            //alert('已分享');
          },
          cancel: function cancel(res) {
            //alert('已取消');
          },
          fail: function fail(res) {
            //alert(JSON.stringify(res));
          }
        });
        // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo({
          title: dataForWeixin.title,
          desc: dataForWeixin.desc,
          link: dataForWeixin.linkurl,
          imgUrl: dataForWeixin.img,
          trigger: function trigger(res) {
            //alert('用户点击分享到微博');
          },
          complete: function complete(res) {
            // alert(JSON.stringify(res));
          },
          success: function success(res) {
            //alert('已分享');
          },
          cancel: function cancel(res) {
            // alert('已取消');
          },
          fail: function fail(res) {
            // alert(JSON.stringify(res));
          }
        });
      })
      wx.error(function (res) {
        // alert("微信验证失败");
      });
    })
}

export default {
  // 获取JSSDK
  getJSSDK: getJSSDK
}
